import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Button } from "./button";
import type { ComponentSize, ComponentTone, ComponentVariant } from "./types";

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  label: string;
  variant?: ComponentVariant;
  tone?: ComponentTone;
  size?: ComponentSize;
};

export function IconButton({
  icon,
  label,
  variant = "ghost",
  tone = "neutral",
  size = "md",
  ...props
}: IconButtonProps) {
  return (
    <Button aria-label={label} title={label} variant={variant} tone={tone} size={size} {...props}>
      {icon}
    </Button>
  );
}
